import { render, staticRenderFns } from "./CardKPI.vue?vue&type=template&id=56d7781c"
import script from "./CardKPI.vue?vue&type=script&lang=js"
export * from "./CardKPI.vue?vue&type=script&lang=js"
import style0 from "./CardKPI.vue?vue&type=style&index=0&id=56d7781c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports